import React from 'react'

type TintableIconProps = {
  color?: string
  size?: number
  strokeWidth?: number
  children?: React.ReactNode
}

export function tintIconNode(node: React.ReactNode, color: string): React.ReactNode {
  if (!React.isValidElement<TintableIconProps>(node)) return node

  const props = node.props
  const isIconLike = 'color' in props || 'size' in props || 'strokeWidth' in props
  const nextChildren =
    props.children === undefined
      ? undefined
      : React.Children.map(props.children, (child) => tintIconNode(child, color))

  if (!isIconLike && props.children === undefined) return node

  return React.cloneElement(node, {
    ...(isIconLike ? { color } : null),
    ...(props.children === undefined ? null : { children: nextChildren }),
  })
}
